import { FC } from 'react';
import { AdminBrandContent } from 'containers/admin';
import { AdminBrandLayout } from 'pages/atoms';

const AdminBrandSettingsPage: FC = () => {
  return (
    <AdminBrandLayout>
      <AdminBrandContent />
    </AdminBrandLayout>
  );
};

export default AdminBrandSettingsPage;
